import { Box } from "@mui/material";
import React from "react";
import DepositIcon from "../../icons/DepositIcon";
import WithdrawIcon from "../../icons/WithdrawIcon";

export default function ResponsiveWalletTag({
  type = "deposit",
  ...restProps
}) {
  return (
    <Box
      {...restProps}
      variant="contained"
      sx={{
        backgroundColor: type === "deposit" ? "#542CE8" : "#B83131",
        borderRadius: "4px",
        width: "24px",
        height: "24px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {type === "deposit" ? (
        <DepositIcon style={{ width: 16, height: 16 }} />
      ) : (
        <WithdrawIcon style={{ width: 16, height: 16 }} />
      )}
    </Box>
  );
}
